<template>
    <AppSelect
        v-model="locale"
        :options="availableLocales.map(lang => ({ label: lang, value: lang }))"
        optionLabel="label"
        optionValue="value"
        @change="switchLanguage(locale)"
        class="w-16"
    />
</template>
<script setup>
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const router = useRouter();
const { locale, availableLocales } = useI18n();

const switchLanguage = newLocale => {
    const currentRoute = router.currentRoute.value;
    const name = currentRoute.name;
    const params = {
        ...currentRoute.params,
        lang: encodeURIComponent(newLocale),
    };
    const query = currentRoute.query;
    router.push({
        name,
        params,
        query,
        hash: '',
    });
};
</script>
<style lang="scss" scoped>
@use '@/scss/variables' as vars;
</style>
